import SkillSchema from 'schemas/skill.schema'
import { z } from 'zod'

const skillValidator = SkillSchema.transform((value) => ({
  ...value,
  label: value.skillObj?.value ?? ''
})).transform((value) => ({
  ...value,
  value: value.skillObj?.id ?? ''
}))

export type ISkill = z.infer<typeof skillValidator>

export default skillValidator
